import { FormGroup, Input, Label } from "reactstrap";
import FieldError from "./FieldError";
import { useBjelinTranslations } from "../../../hooks/TranslationHooks";
import FieldRequired from "./FieldRequired";

const PasswordField = ({ password, callback, errors, required = false }) => {
  const t = useBjelinTranslations();
  return (
    <FormGroup>
      <Label>
        {t("password")}
        {required && <FieldRequired />}
        <Input
          type={"password"}
          autoComplete={"new-password"}
          value={password}
          onChange={e => callback(e.target.value)}
          placeholder={t("password")}
          invalid={!!errors.password}
        />
      </Label>
      <FieldError errors={errors} field={"password"} />
    </FormGroup>
  );
};

export default PasswordField;
